import { useStore } from "vuex";

export function themingCssClass(selectorName: string): string {
  const store = useStore();
  return store.getters.themingCssClass(selectorName);
}

export function themingCssClasses(selectorNames: string[]) {
  return selectorNames.map((selectorName) => themingCssClass(selectorName));
}
